import { render, staticRenderFns } from "./FavoriteItemsByBrand.vue?vue&type=template&id=5ff1e16e&scoped=true&"
import script from "./FavoriteItemsByBrand.vue?vue&type=script&lang=ts&"
export * from "./FavoriteItemsByBrand.vue?vue&type=script&lang=ts&"
import style0 from "./FavoriteItemsByBrand.vue?vue&type=style&index=0&id=5ff1e16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1e16e",
  null
  
)

export default component.exports